angular.module('filters').filter('replaceWaiverMergeTags', function() {
  return function(content = '', contact, country, waiverDateValue) {
    var escapeHtml, getContactAddress, getContactFullName, replaceContent;
    escapeHtml = function(str) {
      if (!str) {
        return '';
      }
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    };
    replaceContent = function() {
      var replacedContent;
      replacedContent = content;
      replacedContent = contact.first_name ? content.replace(/<mark>{First Name}<\/mark>/g, escapeHtml(contact.first_name)) : content;
      if (contact.last_name) {
        replacedContent = replacedContent.replace(/<mark>{Last Name}<\/mark>/g, escapeHtml(contact.last_name));
      }
      if (contact.first_name || contact.last_name) {
        replacedContent = replacedContent.replace(/<mark>{Full Name}<\/mark>/g, escapeHtml(getContactFullName()));
      }
      if (getContactAddress()) {
        replacedContent = replacedContent.replace(/<mark>{Full Address}<\/mark>/g, escapeHtml(getContactAddress()));
      }
      if (waiverDateValue) {
        replacedContent = replacedContent.replace(/<mark>{Current Date}<\/mark>/g, escapeHtml(waiverDateValue));
      }
      return replacedContent;
    };
    getContactFullName = function() {
      return _.compact([contact.first_name, contact.last_name]).join(' ');
    };
    getContactAddress = function() {
      return _.compact([_.compact([contact.address_line_1, contact.address_line_2]).join(' '), contact.address_suburb, _.compact([contact.address_state, contact.address_postcode, country]).join(' ')]).join(', ');
    };
    return replaceContent();
  };
});
